//const baseURL="http://127.0.0.1:9897";
const baseURL="https://www.wowbit.top";
export default {
   baseURL
}



// WEBPACK FOOTER //
// ./static/js/global.js